import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, ShieldCheck, FileText, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import SiteLayout from "@/components/site/SiteLayout";
import { getCmsBaseUrl } from "@/lib/cmsBase";

const CMS_BASE = getCmsBaseUrl();

export default function AdminMetricsPage() {
  return (
    <SiteLayout title="Admin" noindex>
      <div className="min-h-screen bg-secondary/40">
        <header className="border-b border-border bg-white/90 backdrop-blur">
          <div className="container-cv flex items-center justify-between h-16">
            <div className="flex items-center gap-3">
              <Link to="/" className="text-muted-foreground hover:text-primary inline-flex items-center gap-1 text-sm font-bold">
                <ArrowLeft className="h-4 w-4" /> Site
              </Link>
              <span className="text-sm font-display font-bold text-primary tracking-tight">/ Admin</span>
            </div>
            <Button asChild className="h-9 px-3 bg-primary hover:bg-primary/90 text-primary-foreground font-bold">
              <a href={`${CMS_BASE}/admin`} target="_blank" rel="noreferrer">
                Open Strapi admin <ExternalLink className="ml-2 h-4 w-4" />
              </a>
            </Button>
          </div>
        </header>

        <section className="container-cv py-12 md:py-16 max-w-4xl">
          <span className="section-eyebrow">Content operations</span>
          <h1 className="mt-3 font-display text-3xl md:text-5xl font-bold text-primary tracking-tight">
            Manage content in Strapi.
          </h1>
          <p className="mt-4 text-base md:text-lg text-muted-foreground leading-relaxed max-w-2xl">
            The public site now reads CMS data directly from Strapi. Contact submissions are stored in Strapi too, so there is no FastAPI metrics layer in this phase.
          </p>

          <div className="mt-8 grid md:grid-cols-3 gap-5">
            <div className="rounded-2xl border border-border bg-white p-6">
              <ShieldCheck className="h-5 w-5 text-accent" />
              <div className="mt-4 font-display text-lg font-bold text-primary">Admin login</div>
              <p className="mt-2 text-sm text-muted-foreground">
                Open <a className="text-primary font-semibold hover:text-accent" href={`${CMS_BASE}/admin`} target="_blank" rel="noreferrer">/admin</a> on the CMS host and sign in with a Strapi admin account.
              </p>
            </div>
            <div className="rounded-2xl border border-border bg-white p-6">
              <FileText className="h-5 w-5 text-accent" />
              <div className="mt-4 font-display text-lg font-bold text-primary">Content manager</div>
              <p className="mt-2 text-sm text-muted-foreground">
                Blog, case studies, KB articles, product pages and solution pages are edited from the Strapi content manager.
              </p>
            </div>
            <div className="rounded-2xl border border-border bg-white p-6">
              <Mail className="h-5 w-5 text-accent" />
              <div className="mt-4 font-display text-lg font-bold text-primary">Contact submissions</div>
              <p className="mt-2 text-sm text-muted-foreground">
                Website enquiries land in the <code className="rounded bg-secondary px-1.5 py-0.5 text-[11px]">contact-submissions</code> collection.
              </p>
            </div>
          </div>
        </section>
      </div>
    </SiteLayout>
  );
}
